import axios, { encodeData } from "../utils/axios";

export const fetchFlowApplicationStatus = async () => {
  const res = await axios.get("/flowApplicationStatus").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const createFlowApplicationStatus = async (newFlowApplicationStatus) => {
  await axios.post(
    "/flowApplicationStatus/create",
    encodeData(newFlowApplicationStatus)
  );
};

export const updateFlowApplicationStatus = async (
  updatedFlowApplicationStatus
) => {
  await axios.put(
    "/flowApplicationStatus/update",
    encodeData(updatedFlowApplicationStatus)
  );
};

export const deleteFlowApplicationStatus = async (oldFlowApplicationStatus) => {
  await axios.delete("/flowApplicationStatus/delete", {
    data: encodeData(oldFlowApplicationStatus),
  });
};

export const fetchAvailableFlowStatutes = async (fromStatusId, applKindId) => {
  const res = await axios
    .get(
      "/flowApplicationStatus/get-available-statuses/" +
        fromStatusId +
        "&" +
        applKindId
    )
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchReferralForFlowStatus = async (flowId, applKindId) => {
  const res = await axios
    .get("/flowApplicationStatus/referrals-for-flow/", {
      params: { id: flowId, applKindId: applKindId },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};
